// import { Link } from "react-router-dom";
 
// function Home() {
//   return (
//     <div style={{ padding: 40 }}>
//       <h1>Hello World</h1>
//       <p>
//         <Link to="/addplaces">Go to Add Places</Link>
//       </p>
//     </div>
//   );
// }
 
// export default Home;

import { Link } from "react-router-dom";
import "./Home.css";

function Home() {
  return (
    <div className="home">
      <h1>London Mapped</h1>
      <p>
        <Link to="/privacypolicy">Privacy Policy</Link>
      </p>
      <p>
        <Link to="/termsofservice">Terms of Service</Link>
      </p>
    </div>
  );
}

export default Home;